import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { usePartyShellGames } from "../usePartyShellGames";

/**
 * Returns the mode title from the backend registry (localized),
 * falling back to `fallback` when registry isn't available yet.
 */
export function usePartyShareModeTitle(shellId: string, fallback: string): string {
  const { i18n } = useTranslation();
  const { games } = usePartyShellGames();
  return useMemo(() => {
    const g = games.find((x) => x.id === shellId);
    if (!g) return fallback;
    return i18n.language?.startsWith("ar") ? g.nameAr : g.nameEn;
  }, [games, shellId, fallback, i18n.language]);
}

